import { render, staticRenderFns } from "./SendSMSSignature.vue?vue&type=template&id=52e3e308&scoped=true"
import script from "./SendSMSSignature.vue?vue&type=script&lang=js"
export * from "./SendSMSSignature.vue?vue&type=script&lang=js"
import style0 from "./SendSMSSignature.vue?vue&type=style&index=0&id=52e3e308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e3e308",
  null
  
)

export default component.exports